import {createEventHandler} from 'recompose';
import {getOrganization} from '../../app/model/reducers/state';
import {FormModalHOC, modalOptions} from '../../components/modals/FormModal';
import {buildCreateRequestModal, buildUpdateRequestModal} from '../../config/redux-list/requestModals';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {logger} from '../../tasks/redux/logger';
import {AssetForm} from '../components/AssetForm';
import {ASSET_COLLECTION} from '../domain/config';


export function makeEditAssetModal(config) {
  const {
    isCreate,
    prefix,
    getState,
  } = config;

  const buildOnSave = isCreate ? makeOnSave() : void 0;

  const EditAssetModal = FormModalHOC(AssetForm, {
    modalHeaderLabel: isCreate ? 'assets.create.header.label' : 'assets.edit.header.label',
  });

  const builderFn = isCreate ? buildCreateRequestModal : buildUpdateRequestModal;

  return builderFn({
    prefix,
    getState,
    path: ASSET_COLLECTION,
    buildOnSave,
    modalOptions: modalOptions,
    modalComponent: EditAssetModal,
    logger,
  });
}

function makeOnSave() {
  return (state$, dispatch, props$, actions) => {
    const {
      handler: onSave,
      stream: save$,
    } = createEventHandler();

    const orgId$ = state$
      .map(getOrganization)
      .map(getId)
      .distinctUntilChanged()
      .takeUntil(props$.last());

    save$
      .withLatestFrom(orgId$)
      .takeUntil(props$.last())
      .subscribe(([data, orgId]) => {
        const request = {
          ...data,
          orgId,
        };
        dispatch(actions.sendRequest(request));
      });

    return onSave;
  };
}



// WEBPACK FOOTER //
// ./src/js/assets/redux/configEditAssetRequests.js